import { atom } from 'jotai'
import { USDBeneficiaryOptions } from 'types/beneficiaries'

export const usdBeneficiaryBankTypeAtom = atom<USDBeneficiaryOptions>(USDBeneficiaryOptions.CBIT)
